var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',[_c('b-form-checkbox',{attrs:{"checked":_vm.ischecked(_vm.fieldsData.id),"required":_vm.isRequired(_vm.fieldsData.required)},on:{"input":function($event){return _vm.UpdateValue($event)}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.fieldsData.label[_vm.selectlang])}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }